import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import {
  IconModule, IconSize, SmallLogoComponent as PuSmallLogoComponent,
} from '@hglobal/common';
import { environment } from '@pt/environment';

@Component({
  selector: 'pt-small-logo',
  template: '<pu-small-logo [envShortName]="envShortName" [size]="size()"/>',
  styleUrl: './small-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconModule, PuSmallLogoComponent],
})
export class SmallLogoComponent {
  size = input<IconSize>('96');
  readonly envShortName = environment.shortName;
}
